import { render, staticRenderFns } from "./TopPlayers.vue?vue&type=template&id=5cc91116&"
import script from "./TopPlayers.vue?vue&type=script&lang=js&"
export * from "./TopPlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports